import {useEffect, useRef, useState} from 'react';

/*
 * useInView — one-shot IntersectionObserver for the §7.2 reveal pattern.
 * Returns [ref, inView]; once the element intersects it stays true.
 */
export default function useInView({rootMargin = '0px 0px -10% 0px'} = {}) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    if (typeof IntersectionObserver === 'undefined') {
      setInView(true);
      return undefined;
    }
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setInView(true);
            obs.unobserve(entry.target);
          }
        });
      },
      {rootMargin, threshold: 0.05}
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [rootMargin]);
  return [ref, inView];
}
